// ✅ 2025 STANDARD: Client-safe utility functions (no server imports)

// ✅ Helper function to format prices for display
export function formatPlanPrice(amount: number): string {
  return new Intl.NumberFormat('en-NG', {
    style: 'currency',
    currency: 'NGN',
    minimumFractionDigits: 0,
    maximumFractionDigits: 0
  }).format(amount)
}

// ✅ Helper function to get plan billing frequency
export function getPlanBillingFrequency(planSlug: string): string {
  if (planSlug.includes('monthly')) return '/mo'
  if (planSlug.includes('yearly')) return '/yr'
  if (planSlug === 'pay-as-you-go') return '/review'
  return ''
}

// ✅ 2025 STANDARD: Type-safe plan data interface
export interface SubscriptionPlan {
  slug: string
  title: string
  price: number
  discount_price: number | null
  review_limit: number
  duration: string
  is_active: boolean
} 